import {
  params,
  arrayOf,
  string,
  namedFragment,
  fragment,
  shape,
  customType,
  number,
  typename
} from '@thd-nucleus/data-sources';
import { Spotlight } from '../Spotlight';

const targetingTypeShape = shape({
  AdobeTarget: namedFragment({
    inline: true,
    fragmentType: 'AdobeTarget',
  }).shape({
    id: string(),
    mbox: string(),
    __typename: typename('AdobeTarget')
  }),
  MultiArmBandit: namedFragment({
    inline: true,
    fragmentType: 'MultiArmBandit',
  }).shape({
    id: string(),
    campaignId: string(),
    __typename: typename('MultiArmBandit')
  }),
  Innervate: namedFragment({
    inline: true,
    fragmentType: 'Innervate',
  }).shape({
    id: string(),
    tagID: string(),
    adkey: string(),
    __typename: typename('Innervate')
  })
});

const SpotlightSlot = {};
SpotlightSlot.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['Slot'])
      .isRequired(),
  }).shape({
    Slot: namedFragment({
      inline: true,
      fragmentType: 'Slot',
      fragmentAlias: 'SpotlightSlot'
    }).shape({
      componentName: string(),
      id: string(),
      name: string(),
      slotNumber: number(),
      content: shape({
        ...Spotlight.dataModel.component,
      })
    })
  })
};

const SpotlightSelector = {};
SpotlightSelector.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['ComponentSelector']).isRequired(),
  }).shape({
    ComponentSelector: namedFragment({
      inline: true,
      fragmentType: 'ComponentSelector',
      fragmentAlias: 'SpotlightComponentSelector'
    }).shape({
      componentName: string(),
      id: string(),
      targetingType: targetingTypeShape,
      defaultComponent: shape({
        ...SpotlightSlot.dataModel.component
      }),
      variations: arrayOf(
        shape({
          ...SpotlightSlot.dataModel.component
        })
      ),
      __typename: typename('ComponentSelector')
    }),
  }),
};

export { SpotlightSelector };